import swal from 'sweetalert';

(() => {
  angular.module('app').component('commonPatientTicketsDetailSpecialistAmount', {
    templateUrl: require('./specialistAmount.component.html'),
    controller: SpecialistAmountController,
    controllerAs: 'vm',
    bindings: {
      isReadOnly: '<',
      save: '<',
      onDirtyEvent: '<',
      restoreOriginal: '<',
      isHost: '<',
      ticket: '<',
      hasAlerts: '<',
      coPayAmount: '<',
      onEditAmount: '&',
      onSuccessSave: '&',
      onFinishWithoutSaving: '&',
    },
  });

  SpecialistAmountController.$inject = [
    '$uibModal',
    '$scope',
    'Hms.PatientTickets.PatientTicketItem',
  ];

  function SpecialistAmountController($modal, $scope, constsPatientTicketItem) {
    const vm = this;

    vm.constsPatientTicketItem = constsPatientTicketItem;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.checkInput = checkInput;
    vm.tempTreatments = null;
    vm.isOutpatientTicket = false;

    vm.onDirtyEventHandler = onDirtyEventHandler;
    vm.isTotalBillAmountValid = isTotalBillAmountValid;
    vm.areAmountFieldsValid = areAmountFieldsValid;

    function onInit() {
      vm.tempTreatments = angular.copy(vm.ticket.treatments);
      vm.onEditAmount();

      // HACK: HM-3416 Get by service type in future.
      vm.isOutpatientTicket =
        vm.ticket.clinicType === 5 || (vm.ticket.clinicType === 7 && vm.ticket.serviceType === 5);
    }

    function onChanges(changes) {
      if (changes.isReadOnly && !changes.isReadOnly.currentValue) {
        vm.tempTreatments = angular.copy(vm.ticket.treatments);
      }

      if (changes.onDirtyEvent && changes.onDirtyEvent.currentValue) {
        vm.onDirtyEvent.handler = vm.onDirtyEventHandler;
      }

      if (changes.save && !changes.save.isFirstChange()) {
        if (!App.isFormValid($scope.specialistAmountForm) || !vm.isTotalBillAmountValid()) {
          abp.notify.error(App.localize('GeneralInvalidFormInputError'));
          return;
        }

        saveDetails();
      }

      if (changes.restoreOriginal && !changes.restoreOriginal.isFirstChange()) {
        finishWithoutSaving();
      }
    }

    function onDirtyEventHandler() {
      return $scope.specialistAmountForm && $scope.specialistAmountForm.$dirty;
    }

    function finishWithoutSaving() {
      swal(
        {
          title: App.localize('PatientTicketSpecialistDetail_FinishWithoutSavingNarrative'),
          showCancelButton: true,
          closeOnConfirm: false,
          confirmButtonColor: '#1ab394',
        },
        () => {
          vm.ticket.treatments = angular.copy(vm.tempTreatments);
          vm.tempTreatments = null;
          vm.onEditAmount();
          vm.onFinishWithoutSaving();
          $scope.specialistAmountForm.$setPristine();
          swal.close();
        }
      );
    }

    function saveDetails() {
      $modal
        .open({
          templateUrl: require('../editSpecialistAmount/editSpecialistAmount.modal.html'),
          controller: 'common.views.patientTickets.detail.editSpecialistAmountModal as vm',
          backdrop: 'static',
          resolve: {
            ticket() {
              return vm.ticket;
            },
            totalClaimableAmount() {
              return vm.ticket.totalClaimableAmount;
            },
            coPayAmount() {
              return vm.coPayAmount;
            },
          },
        })
        .result.then(() => {
          vm.onSuccessSave();
        });
    }

    function checkInput() {
      vm.onEditAmount();
    }

    function isTotalBillAmountValid() {
      const totalBillAmount = App.roundAmount(
        _.sumBy(vm.ticket.treatments, (d) =>
          App.roundAmount((d.amount || 0) + (d.uncoveredAmount || 0))
        )
      );

      return vm.areAmountFieldsValid() ? vm.ticket.totalClaimableAmount === totalBillAmount : false;
    }

    function areAmountFieldsValid() {
      let isValid = true;
      _.forEach(vm.ticket.treatments, (d) => {
        if (
          typeof d.amount === 'undefined' ||
          d.amount === null ||
          typeof d.uncoveredAmount === 'undefined' ||
          d.uncoveredAmount === null
        ) {
          isValid = false;
        }
      });
      return isValid;
    }
  }
})();
